import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	institutionId: null,
	accessToken: null,
	isAuthenticated: false,
};

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setInstitutionId: (state, action) => {
			state.institutionId = action.payload;
		},
		setAccessToken: (state, action) => {
			state.accessToken = action.payload;
			state.isAuthenticated = !!action.payload;
		},
		setAuthenticated: (state, action) => {
			state.isAuthenticated = action.payload;
		},
		clearAuth: (state) => {
			state.institutionId = null;
			state.accessToken = null;
			state.isAuthenticated = false;
		},
	},
});

export const {
	setInstitutionId,
	setAccessToken,
	setAuthenticated,
	clearAuth,
} = authSlice.actions;

export default authSlice.reducer;
